<template>
    <v-card max-height="fit-content">
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('detalhesViagem.title') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
            <v-expansion-panels v-model="viagemMapPanel" style="margin-top: 15px; margin-bottom: 20px;" accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <h3 style="color: #4a4a4a">{{ $t('detalhesViagem.map.title') }}</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <template v-if="viagemMapPanel === 0">
                            <v-progress-linear v-if="loadingMapaViagem" indeterminate color="primary" class="mb-2" />
                            <v-alert v-else-if="mapaViagemMensagem" type="info" dense text class="mb-2">
                                {{ mapaViagemMensagem }}
                            </v-alert>
                            <div v-show="!loadingMapaViagem" class="d-flex flex-wrap align-center mb-2" style="gap: 8px;">
                                <v-checkbox v-model="mapShowGpsTrack" hide-details dense class="mt-0"
                                    :label="$t('detalhesViagem.map.gpsTrack')" />
                                <v-checkbox v-model="mapShowPlannedRoute" hide-details dense class="mt-0"
                                    :label="$t('detalhesViagem.map.plannedRoute')" />
                                <v-checkbox v-model="mapShowCercas" hide-details dense class="mt-0"
                                    :label="$t('detalhesViagem.map.fences')" />
                                <v-checkbox v-model="mapShowEmbarques" hide-details dense class="mt-0"
                                    :label="$t('detalhesViagem.map.boardings')" />
                                <v-tooltip bottom max-width="280">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                                            <v-checkbox v-model="mapShowPassagemCercas" hide-details dense class="mt-0"
                                                :label="$t('detalhesViagem.map.showPassageTimesOnFences')" />
                                        </div>
                                    </template>
                                    <span>{{ $t('detalhesViagem.map.showPassageTimesOnFencesHint') }}</span>
                                </v-tooltip>
                                <v-checkbox v-model="mapShowDirecaoTrajeto" hide-details dense class="mt-0"
                                    :label="$t('detalhesViagem.map.gpsTrackDirection')" />
                            </div>
                            <div class="detalhes-viagem-map-wrap">
                                <div ref="viagemMapPdfWrap" class="detalhes-viagem-map-pdf-inner">
                                    <l-map v-if="!loadingMapaViagem" ref="viagemMap" :key="leafletKeyViagem" :zoom="mapZoom"
                                        :center="mapCenter" :options="mapLeafletOptions" @ready="onViagemMapReady"
                                        class="detalhes-viagem-lmap">
                                        <l-tile-layer :url="mapTileUrl" :attribution="mapAttribution" />
                                        <l-control position="topright">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-btn small fab :disabled="exportingMapPdf" @click="exportMapPdf">
                                                            <v-icon color="black">mdi-file-pdf-box</v-icon>
                                                        </v-btn>
                                                    </span>
                                                </template>
                                                <span>{{ $t('detalhesViagem.map.exportPdf') }}</span>
                                            </v-tooltip>
                                        </l-control>
                                        <l-polyline v-if="polylineViagemLatLngs.length" :lat-lngs="polylineViagemLatLngs"
                                            :visible="mapShowGpsTrack" color="#E65100" :weight="4" :opacity="0.9" />
                                        <l-marker
                                            v-if="inicioTrajetoLatLng && inicioTrajetoTooltip && polylineViagemLatLngs.length"
                                            :lat-lng="latLngPair(inicioTrajetoLatLng[0], inicioTrajetoLatLng[1])"
                                            :visible="mapShowGpsTrack && mapShowPassagemCercas && !viagemReplayAtivo"
                                            :icon="iconMarcadorInicioTrajeto()"
                                            :z-index-offset="12">
                                            <l-tooltip
                                                :content="inicioTrajetoTooltip"
                                                :options="tooltipPassagemCercaPermOptions"
                                            />
                                        </l-marker>
                                        <l-marker
                                            v-if="viagemReplayAtivo && replayVeiculoLatLng"
                                            :lat-lng="latLngPair(replayVeiculoLatLng[0], replayVeiculoLatLng[1])"
                                            :icon="iconMarcadorVeiculoReplay()"
                                            :z-index-offset="28"
                                        />
                                        <l-marker v-for="(dir, di) in trajetoDirecaoMarkers" :key="`dir-${di}`"
                                            :lat-lng="latLngPair(dir.lat, dir.lng)"
                                            :visible="mapShowGpsTrack && mapShowDirecaoTrajeto && !viagemReplayAtivo"
                                            :icon="iconDirecaoTrajeto(dir.bearing)" :z-index-offset="5" />
                                        <l-geo-json v-for="(rota, i) in mapRotasViagem" :key="`rv-${rota.id_rota}-${i}`"
                                            :geojson="rota.geojson" :options-style="rota.style" :options="rota.options"
                                            :visible="mapShowPlannedRoute" />
                                        <l-geo-json v-for="(cerca, w) in mapCercasGeojsonViagem"
                                            :key="`cv-${cerca.id_cerca}-${w}`" :geojson="cerca.geojson"
                                            :options="cerca.options" :options-style="cerca.style" :visible="mapShowCercas" />
                                        <l-circle v-for="(cerca, w) in mapCercasCircularesViagem"
                                            :key="`ccv-${cerca.id_cerca}-${w}`"
                                            :lat-lng="latLngPair(cerca.lat_centro, cerca.lng_centro)"
                                            :radius="Number(cerca.raio_mts) || 0" :color="cerca._strokeColor"
                                            :fill-color="cerca._fillColor" :fill-opacity="0.25" :weight="2"
                                            :visible="mapShowCercas">
                                            <l-tooltip
                                                v-if="mapShowPassagemCercas && cerca._passagemTooltipPermanente"
                                                :content="cerca._passagemTooltipPermanente"
                                                :options="tooltipPassagemCercaPermOptions"
                                            />
                                        </l-circle>
                                        <l-marker v-for="(reg, k) in mapEmbarqueMarkersViagem"
                                            :key="`embv-${reg.id_embarque}-${k}`"
                                            :lat-lng="latLngPair(reg.lat, reg.lng)" :visible="mapShowEmbarques"
                                            :icon="iconEmbarqueViagem(reg)" :z-index-offset="25">
                                            <l-popup>
                                                <span>{{ reg.nome_completo }}</span><br />
                                                <span>{{ reg.dt_embarque_extenso }}</span><br />
                                                <span>{{ reg.autorizado_extenso }}</span><br />
                                                <span v-if="reg.nome_cerca || reg.cod_cerca">{{ $t('relBoarding.parada') }}:
                                                    {{ reg.nome_cerca || reg.cod_cerca }}</span>
                                            </l-popup>
                                        </l-marker>
                                    </l-map>
                                </div>
                                <v-tooltip v-if="!loadingMapaViagem && !mapaViagemMensagem" left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            class="detalhes-viagem-map-fab"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-btn
                                                fab
                                                small
                                                color="primary"
                                                :disabled="!podeReproduzirTrajetoMapa"
                                                @click="toggleReproducaoTrajetoMapa"
                                            >
                                                <v-icon color="white">
                                                    {{ viagemReplayAtivo ? 'mdi-stop' : 'mdi-play' }}
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>{{ viagemReplayAtivo ? $t('detalhesViagem.map.replayStop') : $t('detalhesViagem.map.replayPlay') }}</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels style="margin-top: 15px; margin-bottom: 20px;" accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <h3 style="color: #4a4a4a">{{ cercasTitle }}</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <merus-data-table :headers="headersDetalhes" :items="cercas" :default-multi-sort="defaultSort"
                            :loading="loadingCercas" :loading-text="$t('detalhesViagem.fences.loading')"
                            @update:displayedItems="displayedItemsForExportCercas = $event">
                            <template v-slot:toolbar>
                                <CadastroToolbar :token="token" :title="$t('detalhesViagem.fences.toolbarTitle')"
                                    :items="displayedItemsForExportCercas !== null ? displayedItemsForExportCercas : cercas"
                                    :csv-title="$t('detalhesViagem.fences.csvTitle')" :csv-headers="headersDetalhes"
                                    :pdf-title="$t('detalhesViagem.fences.pdfTitle')" :pdf-headers="headersDetalhes"
                                    :pdf-filename="$t('detalhesViagem.fences.pdfFilename')" hide-search>
                                </CadastroToolbar>
                            </template>
                        </merus-data-table>
                        <div class="mb-4">
                            <br><br>
                            <h3 style="color: #4a4a4a">{{ TimelineTitle }}</h3>
                            <v-progress-linear v-if="loadingCercas" indeterminate color="primary" class="mb-2" />
                            <v-alert v-else-if="!cercasTimelineHasData" type="info" dense text class="mb-2">
                                {{ $t('detalhesViagem.fences.timelineEmpty') }}
                            </v-alert>
                            <template v-else>
                                <apexchart
                                    :key="cercasTimelineChartKey"
                                    type="scatter"
                                    width="100%"
                                    :height="cercasTimelineHeight"
                                    :options="cercasTimelineOptions"
                                    :series="cercasTimelineSeries"
                                />
                                <p v-if="cercasTimelineHasEstimated" class="text-caption grey--text text--darken-1 mb-0 mt-1">
                                    {{ $t('detalhesViagem.fences.timelineEstimatedCaption') }}
                                </p>
                            </template>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels v-if="!tempoReal && viagem.id_viagem_grid" style="margin-top: 15px;" accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <h3 style="color: #4a4a4a">{{ $t('hodometroViagem.title') }}</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <HodometrosViagemInfo :id-viagem-grid="viagem.id_viagem_grid"></HodometrosViagemInfo>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels style="margin-top: 15px; margin-bottom: 20px;" accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <h3 style="color: #4a4a4a">{{ $t('dashboard.embarkations') }}</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card flat class="mb-4" color="grey lighten-4">
                            <v-card-text class="pb-2">
                                <v-row dense align="stretch">
                                    <v-col cols="12" sm="6" md="4">
                                        <div class="d-flex align-center flex-wrap emb-stat-block primary--text">
                                            <v-icon color="primary" class="mr-2">mdi-bus-side</v-icon>
                                            <div>
                                                <div class="text-caption grey--text text--darken-2 mb-0">
                                                    {{ $t('detalhesViagem.fences.vehicleOccupancy') }}
                                                </div>
                                                <div class="text-h6 font-weight-bold primary--text">
                                                    {{ statsEmbarques.validos }} / {{ lotacaoVeiculo }}
                                                    <span v-if="Number(lotacaoVeiculo) > 0" class="text-body-2 font-weight-medium">
                                                        ({{ taxaOcupacao }}%)
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="2">
                                        <div class="emb-stat-block">
                                            <div class="text-caption grey--text text--darken-2">
                                                {{ $t('detalhesViagem.fences.validBoardings') }}
                                            </div>
                                            <div class="text-h6 font-weight-bold" style="color: #1976d2;">
                                                {{ statsEmbarques.validos }}
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="2">
                                        <div class="emb-stat-block">
                                            <div class="text-caption grey--text text--darken-2">
                                                {{ $t('detalhesViagem.fences.authorizedCount') }}
                                            </div>
                                            <div class="text-h6 font-weight-bold success--text">
                                                {{ statsEmbarques.autorizados }}
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="2">
                                        <div class="emb-stat-block">
                                            <div class="text-caption grey--text text--darken-2">
                                                {{ $t('detalhesViagem.fences.wrongRouteCount') }}
                                            </div>
                                            <div class="text-h6 font-weight-bold warning--text text--darken-2">
                                                {{ statsEmbarques.rotaErrada }}
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="2">
                                        <div class="emb-stat-block">
                                            <div class="text-caption grey--text text--darken-2">
                                                {{ $t('detalhesViagem.fences.deniedCount') }}
                                            </div>
                                            <div class="text-h6 font-weight-bold error--text">
                                                {{ statsEmbarques.naoAutorizados }}
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <merus-data-table :headers="headersEventos" :items="eventos" :loading="loadingEventos"
                            :item-class="embarqueRowClass"
                            :loading-text="$t('detalhesViagem.fences.loadingEvents')"
                            @update:displayedItems="displayedItemsForExportEventos = $event">
                            <template v-slot:toolbar>
                                <CadastroToolbar :token="token" :title="$t('detalhesViagem.fences.events')"
                                    :items="displayedItemsForExportEventos !== null ? displayedItemsForExportEventos : eventos"
                                    csv-title="eventos-embarque.csv" :csv-headers="headersEventos"
                                    :pdf-title="$t('detalhesViagem.fences.events')" :pdf-headers="headersEventos"
                                    pdf-filename="eventos-embarque.pdf" hide-search>
                                </CadastroToolbar>
                            </template>
                        </merus-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>

        <v-dialog v-model="exportingMapPdf" persistent max-width="320">
            <v-card>
                <v-card-text class="pt-4 text-center">{{ $t('detalhesViagem.map.exportProgress') }}</v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import apiController from "@/utils/apiController";
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from "../components/Toolbars/CadastroToolbar.vue";
import HodometrosViagemInfo from "@/components/Viagem/HodometrosViagemInfo.vue";
import EventBus from "@/utils/eventBus";
import DateUtils from "@/utils/dateutils";
import L from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LCircle,
    LGeoJson,
    LTooltip,
    LPolyline,
    LControl,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import { mdiAccount } from "@mdi/js";

const MAP_DEFAULT_CENTER = [-22.88746, -43.29185];

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        HodometrosViagemInfo,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LCircle,
        LGeoJson,
        LTooltip,
        LPolyline,
        LControl,
    },
    props: {
        viagem: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        /** true = painel tempo real (getetaviagem / id_viagem_realizada); false = relatórios (getviagemgridcercas / id_viagem_grid) */
        tempoReal: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        displayedItemsForExportCercas: null,
        displayedItemsForExportEventos: null,
        cercas: [],
        loadingCercas: false,
        dti: null,
        dtf: null,
        eventos: [],
        embarquesComCoordenadas: [],
        loadingEventos: false,
        taxaOcupacao: 0,
        veiculo: null,
        viagemMapPanel: null,
        loadingMapaViagem: false,
        mapaViagemMensagem: "",
        mapaTripKeyCarregado: null,
        leafletKeyViagem: 0,
        mapZoom: 13,
        mapCenter: MAP_DEFAULT_CENTER.slice(),
        mapTileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        mapAttribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapLeafletOptions: {
            zoomSnap: 0.5,
            zoomAnimation: false,
            fadeAnimation: false,
            markerZoomAnimation: false,
        },
        mapShowGpsTrack: true,
        mapShowPlannedRoute: true,
        mapShowCercas: true,
        mapShowEmbarques: true,
        mapShowPassagemCercas: true,
        mapShowDirecaoTrajeto: true,
        trajetoDirecaoMarkers: [],
        inicioTrajetoLatLng: null,
        inicioTrajetoTooltip: "",
        posicoesViagem: [],
        polylineViagemLatLngs: [],
        mapRotasViagem: [],
        mapCercasGeojsonViagem: [],
        mapCercasCircularesViagem: [],
        mapEmbarqueMarkersViagem: [],
        exportingMapPdf: false,
        /** Leaflet: tooltip fixo compacto só com horário de passagem */
        tooltipPassagemCercaPermOptions: {
            permanent: true,
            direction: "top",
            offset: [0, -6],
            className: "detalhes-viagem-cerca-passagem-tt",
            opacity: 0.92,
        },
        viagemReplayAtivo: false,
        replayVeiculoLatLng: null,
        viagemReplayTimerId: null,
        viagemReplayEndTimerId: null,
        viagemMapSnapshotReplay: null,
    }),
    computed: {
        podeReproduzirTrajetoMapa() {
            if (this.loadingMapaViagem || this.mapaViagemMensagem) return false;
            if (this.viagemReplayAtivo) return true;
            const n = (this.polylineViagemLatLngs && this.polylineViagemLatLngs.length) || 0;
            return n >= 2;
        },
        cercasTitle() {
            return this.$t('detalhesViagem.fences.title');
        },
        headersDetalhes() {
            return [
                { text: this.$t('detalhesViagem.headers.fence'), value: "nome_cerca", sortable: true, filtrable: true },
                { text: this.$t('detalhesViagem.headers.address'), value: "endereco", sortable: true, filtrable: true },
                { text: this.$t('detalhesViagem.headers.passageDate'), value: "dt_passou_na_cerca", sortable: true, filtrable: false, align: ' d-none' },
                { text: this.$t('detalhesViagem.headers.estimatedTimeArrival'), value: "dt_chegada_prevista_extenso", sortable: false, filtrable: true },
                { text: this.$t('detalhesViagem.headers.passageDate'), value: "dt_passou_na_cerca_extenso", sortable: false, filtrable: true },
                { text: this.$t('detalhesViagem.headers.delay'), value: "atraso", sortable: true, filtrable: true }
            ];
        },
        TimelineTitle() {
            return this.$t('detalhesViagem.fences.timelineTitle');
        },
        headersEventos() {
            return [
                { text: this.$t('datetime.date'), value: "dt_evento_extenso", sortable: true, filtrable: true },
                { text: this.$t('detalhesViagem.fences.people'), value: "nome_completo", sortable: true, filtrable: true },
                { text: this.$t('detalhesViagem.fences.authorized'), value: "autorizado_extenso", sortable: true, filtrable: true }
            ];
        },
        defaultSort() {
            return [
                { value: 'ordem_parada', options: { text: this.$t('detalhesViagem.sortOptions.ascending'), value: 1 } },
                { value: 'dt_passou_na_cerca', options: { text: this.$t('detalhesViagem.sortOptions.ascending'), value: 1 } },
            ];
        },
        statsEmbarques() {
            const lista = this.eventos || [];
            let autorizados = 0;
            let naoAutorizados = 0;
            let rotaErrada = 0;
            let validos = 0;
            for (let i = 0; i < lista.length; i++) {
                const a = lista[i].autorizado;
                const n = a === null || a === undefined || a === '' ? NaN : Number(a);
                if (n === 0) {
                    naoAutorizados += 1;
                } else if (n === 1) {
                    autorizados += 1;
                } else {
                    rotaErrada += 1;
                }
                if (n === 1 || n === 2) {
                    validos += 1;
                }
            }
            return {
                autorizados,
                naoAutorizados,
                rotaErrada,
                validos,
                total: lista.length
            };
        },
        lotacaoVeiculo() {
            const n = Number(this.viagem?.lotacao);
            return Number.isFinite(n) && n >= 0 ? n : 0;
        },
        cercasTimelineModel() {
            const labelInicio = this.$t('detalhesViagem.fences.timelineStart');
            const labelFim = this.$t('detalhesViagem.fences.timelineEnd');
            const { tripStartMs, tripEndMs } = this.tripWindowMsMs();
            let windowStart = tripStartMs;
            let windowEnd = tripEndMs;
            if (windowStart != null && windowEnd == null) {
                windowEnd = windowStart + 4 * 60 * 60 * 1000;
            }
            if (windowStart != null && windowEnd != null && windowStart > windowEnd) {
                const tmp = windowStart;
                windowStart = windowEnd;
                windowEnd = tmp;
            }

            const cercasOrdenadas = [...(this.cercas || [])].sort((a, b) => {
                const oa = a && a.ordem_parada != null ? Number(a.ordem_parada) : NaN;
                const ob = b && b.ordem_parada != null ? Number(b.ordem_parada) : NaN;
                if (Number.isFinite(oa) && Number.isFinite(ob) && oa !== ob) return oa - ob;
                if (Number.isFinite(oa) && !Number.isFinite(ob)) return -1;
                if (!Number.isFinite(oa) && Number.isFinite(ob)) return 1;
                const ma = this.parseTimestampMs(a && a.dt_passou_na_cerca);
                const mb = this.parseTimestampMs(b && b.dt_passou_na_cerca);
                if (ma != null && mb != null && ma !== mb) return ma - mb;
                if (ma != null && mb == null) return -1;
                if (ma == null && mb != null) return 1;
                return 0;
            });

            const fenceCount = cercasOrdenadas.length;
            const span = (windowStart != null && windowEnd != null)
                ? Math.max(windowEnd - windowStart, 60 * 1000)
                : null;

            /** @type {{ label: string, ms: number, serie: string, estimado: boolean }[]} */
            const events = [];

            if (windowStart != null) {
                events.push({
                    label: labelInicio,
                    ms: windowStart,
                    serie: "inicio",
                    estimado: false,
                });
            }

            const nameCounts = Object.create(null);
            cercasOrdenadas.forEach((row, index) => {
                if (!row) return;
                let baseName = (row.nome_cerca || row.cod_cerca || "").toString().trim();
                if (!baseName) {
                    baseName = row.id_cerca != null
                        ? `${this.$t('detalhesViagem.headers.fence')} ${row.id_cerca}`
                        : `${this.$t('detalhesViagem.headers.fence')} ${index + 1}`;
                }
                nameCounts[baseName] = (nameCounts[baseName] || 0) + 1;
                const label = nameCounts[baseName] > 1
                    ? `${baseName} (${nameCounts[baseName]})`
                    : baseName;

                const msPassagem = this.parseTimestampMs(row.dt_passou_na_cerca);
                if (msPassagem != null) {
                    events.push({
                        label,
                        ms: msPassagem,
                        serie: "passou",
                        estimado: false,
                    });
                    return;
                }
                if (windowStart != null && span != null) {
                    const fraction = (index + 1) / (fenceCount + 1);
                    events.push({
                        label,
                        ms: windowStart + Math.round(span * fraction),
                        serie: "naoPassou",
                        estimado: true,
                    });
                }
            });

            if (windowEnd != null) {
                events.push({
                    label: labelFim,
                    ms: windowEnd,
                    serie: "fim",
                    estimado: false,
                });
            }

            const categories = events.map((e) => e.label);
            const seriesBuckets = {
                inicio: [],
                passou: [],
                naoPassou: [],
                fim: [],
            };
            events.forEach((e, i) => {
                if (!seriesBuckets[e.serie]) return;
                seriesBuckets[e.serie].push({
                    x: e.ms,
                    y: i,
                    meta: {
                        label: e.label,
                        estimado: e.estimado,
                        naoPassou: e.serie === "naoPassou",
                        ms: e.ms,
                    },
                });
            });

            const seriesDefs = [
                { key: "inicio", name: this.$t('detalhesViagem.fences.timelineLegendStart'), color: "#2563eb" },
                { key: "passou", name: this.$t('detalhesViagem.fences.timelineLegendPassed'), color: "#16a34a" },
                { key: "naoPassou", name: this.$t('detalhesViagem.fences.timelineLegendMissed'), color: "#94a3b8" },
                { key: "fim", name: this.$t('detalhesViagem.fences.timelineLegendEnd'), color: "#7c3aed" },
            ];
            const series = seriesDefs
                .filter((s) => seriesBuckets[s.key].length > 0)
                .map((s) => ({
                    name: s.name,
                    color: s.color,
                    data: seriesBuckets[s.key],
                }));

            return {
                categories,
                series,
                hasMissed: seriesBuckets.naoPassou.length > 0,
                hasEstimated: events.some((e) => e.estimado),
                hasData: events.length > 0,
                height: Math.max(220, 36 * Math.max(events.length, 1)),
            };
        },
        cercasTimelineHasData() {
            return !!(this.cercasTimelineModel && this.cercasTimelineModel.hasData);
        },
        cercasTimelineHasMissed() {
            return !!(this.cercasTimelineModel && this.cercasTimelineModel.hasMissed);
        },
        cercasTimelineHasEstimated() {
            return !!(this.cercasTimelineModel && this.cercasTimelineModel.hasEstimated);
        },
        cercasTimelineHeight() {
            return (this.cercasTimelineModel && this.cercasTimelineModel.height) || 220;
        },
        cercasTimelineSeries() {
            return (this.cercasTimelineModel && this.cercasTimelineModel.series) || [];
        },
        cercasTimelineChartKey() {
            const n = (this.cercas && this.cercas.length) || 0;
            return `cercas-tl-${this.tripKeyMapa()}-${n}`;
        },
        cercasTimelineOptions() {
            const categories = (this.cercasTimelineModel && this.cercasTimelineModel.categories) || [];
            const estimatedSuffix = this.$t('detalhesViagem.fences.timelineEstimatedSuffix');
            const missedLabel = this.$t('detalhesViagem.fences.timelineLegendMissed');
            const self = this;
            return {
                chart: {
                    id: "cercas-timeline",
                    type: "scatter",
                    toolbar: { show: true },
                    zoom: { enabled: false },
                    animations: { enabled: false },
                    fontFamily: "inherit",
                },
                colors: this.cercasTimelineSeries.map((s) => s.color),
                markers: {
                    size: 8,
                    strokeWidth: 1,
                    strokeColors: "#fff",
                },
                legend: {
                    position: "right",
                    verticalAlign: "middle",
                },
                grid: {
                    padding: { left: 8, right: 12 },
                },
                tooltip: {
                    shared: false,
                    intersect: true,
                    custom({ seriesIndex, dataPointIndex, w }) {
                        const point = w.config.series[seriesIndex]
                            && w.config.series[seriesIndex].data[dataPointIndex];
                        const meta = point && point.meta;
                        if (!meta) return "";
                        const esc = (s) => String(s == null ? "" : s)
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/"/g, "&quot;");
                        const hora = self.formatTimelineHora(meta.ms);
                        const horaTxt = meta.estimado ? `${hora} ${estimatedSuffix}` : hora;
                        const statusLine = meta.naoPassou
                            ? `<div>${esc(missedLabel)}</div>`
                            : "";
                        return `<div class="apexcharts-tooltip-title" style="font-family:inherit;padding:6px 10px;">`
                            + `<div><strong>${esc(meta.label)}</strong></div>`
                            + statusLine
                            + `<div>${esc(horaTxt)}</div>`
                            + `</div>`;
                    },
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        datetimeUTC: false,
                        format: "HH:mm",
                        rotate: -35,
                        rotateAlways: categories.length > 4,   
                        offsetY: -3,    
                    },
                    title: {
                        text: this.$t('detalhesViagem.fences.timelineAxisTime'),
                        offsetY: 3,
                    },
                },
                yaxis: {
                    min: -0.5,
                    max: Math.max(categories.length - 0.5, 0.5),
                    tickAmount: Math.max(categories.length - 1, 1),
                    reversed: true,
                    labels: {
                        minWidth: 80,
                        maxWidth: 220,
                        formatter(val) {
                            const i = Math.round(val);
                            if (i < 0 || i >= categories.length) return "";
                            const label = categories[i] || "";
                            return label.length > 36 ? `${label.slice(0, 34)}…` : label;
                        },
                    },
                },
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
        viagemMapPanel(val) {
            if (val === 0) {
                this.$nextTick(() => this.prepararMapaViagemAoAbrir());
            }
        },
        mapShowPassagemCercas() {
            this.$nextTick(() => this.syncPassagemCercasTooltips());
        }
    },
    mounted() {
        this.initialize();
    },
    beforeDestroy() {
        this.pararReproducaoTrajetoMapa();
    },
    methods: {
        tripKeyMapa() {
            const g = this.viagem && this.viagem.id_viagem_grid != null ? String(this.viagem.id_viagem_grid) : "";
            const r = this.viagem && this.viagem.id_viagem_realizada != null ? String(this.viagem.id_viagem_realizada) : "";
            return `${g}|${r}`;
        },
        async aguardarFimCarregamentoDetalhes() {
            const max = 50;
            let i = 0;
            while ((this.loadingCercas || this.loadingEventos) && i < max) {
                await new Promise((r) => setTimeout(r, 100));
                i += 1;
            }
        },
        async prepararMapaViagemAoAbrir() {
            await this.aguardarFimCarregamentoDetalhes();
            await this.carregarMapaViagem();
            await this.$nextTick();
            this.invalidateViagemMap();
            setTimeout(() => {
                this.invalidateViagemMap();
                this.syncPassagemCercasTooltips();
                this.ajustarBoundsViagemMap();
            }, 280);
        },
        parseDataFlexivel(val) {
            if (!val) return null;
            if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val;
            const s = String(val).trim();
            if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
                const d = new Date(s.replace(" ", "T"));
                if (!Number.isNaN(d.getTime())) return d;
            }
            if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(s)) {
                const sql = DateUtils.getDateSQLFormatted(s);
                if (sql) {
                    const d = new Date(sql.replace("T", " "));
                    if (!Number.isNaN(d.getTime())) return d;
                }
            }
            const d2 = new Date(s);
            return Number.isNaN(d2.getTime()) ? null : d2;
        },
        parseTimestampMs(val) {
            if (val == null || val === "") return null;
            if (typeof val === "number" && Number.isFinite(val)) return val;
            const d = val instanceof Date ? val : this.parseDataFlexivel(val);
            if (!d || Number.isNaN(d.getTime())) return null;
            return d.getTime();
        },
        tripWindowMsMs() {
            const rawStart =
                this.viagem.horario_saida_realizada ||
                this.viagem.dt_inicio ||
                this.viagem.horario_saida_prevista ||
                this.viagem.horario_saida_previsto;
            const rawEnd =
                this.viagem.horario_chegada_realizada ||
                this.viagem.dt_fim ||
                this.viagem.horario_chegada_prevista ||
                this.viagem.horario_chegada_previsto;
            const tripStartMs = this.parseTimestampMs(rawStart);
            const tripEndMs = this.parseTimestampMs(rawEnd);
            return { tripStartMs, tripEndMs };
        },
        janelaSqlViagem() {
            const rawStart =
                this.viagem.horario_saida_realizada ||
                this.viagem.dt_inicio ||
                this.viagem.horario_saida_prevista ||
                this.viagem.horario_saida_previsto;
            const rawEnd =
                this.viagem.horario_chegada_realizada ||
                this.viagem.dt_fim ||
                this.viagem.horario_chegada_prevista ||
                this.viagem.horario_chegada_previsto;
            let dti = null;
            let dtf = null;
            const ds = this.parseDataFlexivel(rawStart);
            const de = this.parseDataFlexivel(rawEnd);
            if (ds) dti = DateUtils.getDateSQLFormatted(ds);
            if (de) dtf = DateUtils.getDateSQLFormatted(de);
            if (dti && !dtf && ds) {
                const fim = new Date(ds.getTime() + 4 * 60 * 60 * 1000);
                dtf = DateUtils.getDateSQLFormatted(fim);
            }
            if (!dti || !dtf) {
                return { dti: null, dtf: null };
            }
            const t0 = new Date(dti.replace("T", " "));
            const t1 = new Date(dtf.replace("T", " "));
            if (!Number.isNaN(t0.getTime()) && !Number.isNaN(t1.getTime()) && t0 > t1) {
                return { dti: dtf, dtf: dti };
            }
            return { dti, dtf };
        },
        idVeiculoParaMapa() {
            const v = this.viagem;
            if (!v) return null;
            const id = v.id_veiculo_realizado ?? v.id_veiculo ?? v.id_veiculo_realizada;
            if (id == null || id === "") return null;
            const n = Number(id);
            return Number.isFinite(n) && n > 0 ? n : null;
        },
        idLinhaParaMapa() {
            const v = this.viagem;
            if (v && v.id_linha != null && v.id_linha !== "") {
                const n = Number(v.id_linha);
                if (Number.isFinite(n) && n > 0) return n;
            }
            const c0 = this.cercas && this.cercas[0];
            if (c0 && c0.id_linha != null) {
                const n = Number(c0.id_linha);
                if (Number.isFinite(n) && n > 0) return n;
            }
            return null;
        },
        passagemPorIdCerca() {
            const m = new Map();
            (this.cercas || []).forEach((row) => {
                if (!row || row.id_cerca == null) return;
                if (row.dt_passou_na_cerca == null || row.dt_passou_na_cerca === "") return;
                const txt = row.dt_passou_na_cerca_extenso || row.dt_passou_na_cerca || "";
                if (!txt) return;
                m.set(String(row.id_cerca), txt);
            });
            return m;
        },
        formatTimelineHora(ms) {
            if (ms == null || !Number.isFinite(ms)) return "";
            const d = new Date(ms);
            if (Number.isNaN(d.getTime())) return "";
            const pad = (n) => (n < 10 ? "0" : "") + n;
            return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        /**
         * Tooltip do mapa: só horário, compacto (ex.: "15/05/2026 14:30:02" → "14:30:02").
         */
        textoTooltipSomenteHorarioPassagem(valorBruto) {
            const s = (valorBruto == null ? "" : String(valorBruto)).trim();
            if (!s) return "";
            if (/^\d{1,2}:\d{2}/.test(s) && !/\d{4}-\d{2}-\d{2}/.test(s) && !/\d{1,2}\/\d{1,2}\/\d{4}/.test(s)) {
                return s;
            }
            const isoCandidate = s.includes("T") ? s : s.replace(" ", "T");
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(isoCandidate)) {
                const d = new Date(isoCandidate);
                if (!Number.isNaN(d.getTime())) {
                    const pad = (n) => (n < 10 ? "0" : "") + n;
                    return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                }
            }
            const parts = s.split(/\s+/).filter(Boolean);
            if (parts.length >= 2) {
                const last = parts[parts.length - 1];
                if (/^\d{1,2}:\d{2}/.test(last)) return last;
            }
            return s.length > 12 ? s.slice(-8) : s;
        },
        bearingGraus(lat1, lng1, lat2, lng2) {
            const φ1 = (lat1 * Math.PI) / 180;
            const φ2 = (lat2 * Math.PI) / 180;
            const Δλ = ((lng2 - lng1) * Math.PI) / 180;
            const y = Math.sin(Δλ) * Math.cos(φ2);
            const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
            const θ = Math.atan2(y, x);
            return ((θ * 180) / Math.PI + 360) % 360;
        },
        parseRumoGraus(rumoRaw) {
            if (rumoRaw == null || rumoRaw === "") return null;
            const r = parseFloat(String(rumoRaw).replace(",", "."));
            if (Number.isNaN(r)) return null;
            const norm = ((r % 360) + 360) % 360;
            /* 0 (ou 360°) costuma indicar "sem rumo" no equipamento — usar azimute entre pontos */
            if (norm === 0) return null;
            return norm;
        },
        buildMarcadoresDirecaoTrajetoDesdePosicoes(posicoes, latlngs) {
            const out = [];
            if (!latlngs || latlngs.length < 2) return out;
            const maxMarcadores = 40;
            const step = Math.max(1, Math.ceil((latlngs.length - 1) / maxMarcadores));
            for (let i = 0; i < latlngs.length - 1; i += step) {
                const [la1, ln1] = latlngs[i];
                const [la2, ln2] = latlngs[i + 1];
                const p = Array.isArray(posicoes) ? posicoes[i] : null;
                let bearing = this.parseRumoGraus(p && p.rumo);
                if (bearing == null) {
                    bearing = this.bearingGraus(la1, ln1, la2, ln2);
                }
                if (bearing == null || Number.isNaN(bearing)) continue;
                out.push({
                    lat: la1,
                    lng: ln1,
                    bearing: ((bearing % 360) + 360) % 360,
                });
            }
            return out;
        },
        iconDirecaoTrajeto(bearing) {
            const b = Number(bearing) || 0;
            const sz = 16;
            const html =
                `<div class="detalhes-viagem-dir-arrow" style="transform:rotate(${b}deg);width:${sz}px;height:${sz}px;">` +
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${sz}" height="${sz}" ` +
                `fill="#BF360C" stroke="#ffffff" stroke-width="1.2" stroke-linejoin="round">` +
                `<path d="M12 3 L21 19 L12 15 L3 19 Z"/>` +
                `</svg></div>`;
            return L.divIcon({
                className: "detalhes-viagem-dir-marker",
                html,
                iconSize: [sz, sz],
                iconAnchor: [sz / 2, sz / 2],
            });
        },
        iconMarcadorInicioTrajeto() {
            const sz = 6;
            return L.divIcon({
                className: "detalhes-viagem-inicio-trajeto-marker",
                html: `<div class="detalhes-viagem-inicio-trajeto-dot" style="width:${sz}px;height:${sz}px;"></div>`,
                iconSize: [sz, sz],
                iconAnchor: [sz / 2, sz / 2],
            });
        },
        syncPassagemCercasTooltips() {
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (!mo) return;
            const show = this.mapShowPassagemCercas;
            const visit = (ly) => {
                if (!ly) return;
                if (ly._dvPassagemTexto != null && ly._dvPassagemTexto !== "") {
                    if (show) {
                        if (!ly.getTooltip || !ly.getTooltip()) {
                            ly.bindTooltip(ly._dvPassagemTexto, { ...ly._dvPassagemOpts });
                        }
                        if (ly.openTooltip) ly.openTooltip();
                    } else if (ly.getTooltip && ly.getTooltip()) {
                        ly.unbindTooltip();
                    }
                }
                if (ly.eachLayer) ly.eachLayer(visit);
            };
            mo.eachLayer(visit);
        },
        iconMarcadorVeiculoReplay() {
            const sz = 16;
            return L.divIcon({
                className: "detalhes-viagem-replay-veiculo-marker",
                html: `<div class="detalhes-viagem-replay-veiculo-dot" style="width:${sz}px;height:${sz}px;"></div>`,
                iconSize: [sz, sz],
                iconAnchor: [sz / 2, sz / 2],
            });
        },
        buildViagemReplayParesGps() {
            const posicoes = this.posicoesViagem || [];
            const pairs = [];
            posicoes.forEach((p) => {
                const la = parseFloat(p.lat);
                const ln = parseFloat(p.lng);
                if (!Number.isNaN(la) && !Number.isNaN(ln) && !(la === 0 && ln === 0)) {
                    pairs.push({
                        lat: la,
                        lng: ln,
                        ms: this.parseTimestampMs(p.dt_posicao || p.dt_posicao_extenso),
                    });
                }
            });
            const { tripStartMs, tripEndMs } = this.tripWindowMsMs();
            if (
                pairs.length &&
                tripStartMs != null &&
                tripEndMs != null &&
                !Number.isNaN(tripStartMs) &&
                !Number.isNaN(tripEndMs) &&
                tripEndMs >= tripStartMs
            ) {
                for (let i = 0; i < pairs.length; i++) {
                    if (pairs[i].ms == null) {
                        const r = pairs.length <= 1 ? 0 : i / (pairs.length - 1);
                        pairs[i].ms = Math.round(tripStartMs + r * (tripEndMs - tripStartMs));
                    }
                }
            }
            return pairs;
        },
        capturarSnapshotMapaParaReplay() {
            return {
                mapZoom: this.mapZoom,
                mapCenter: (this.mapCenter || []).slice(),
                polylineViagemLatLngs: JSON.parse(JSON.stringify(this.polylineViagemLatLngs || [])),
                trajetoDirecaoMarkers: JSON.parse(JSON.stringify(this.trajetoDirecaoMarkers || [])),
                inicioTrajetoLatLng: this.inicioTrajetoLatLng ? this.inicioTrajetoLatLng.slice() : null,
                inicioTrajetoTooltip: this.inicioTrajetoTooltip,
                mapCercasCircularesViagem: JSON.parse(JSON.stringify(this.mapCercasCircularesViagem || [])),
                mapEmbarqueMarkersViagem: JSON.parse(JSON.stringify(this.mapEmbarqueMarkersViagem || [])),
                mapShowGpsTrack: this.mapShowGpsTrack,
                mapShowPlannedRoute: this.mapShowPlannedRoute,
                mapShowCercas: this.mapShowCercas,
                mapShowEmbarques: this.mapShowEmbarques,
                mapShowPassagemCercas: this.mapShowPassagemCercas,
                mapShowDirecaoTrajeto: this.mapShowDirecaoTrajeto,
            };
        },
        restaurarSnapshotMapaReplay(snap) {
            if (!snap) return;
            this.mapZoom = snap.mapZoom;
            this.mapCenter = (snap.mapCenter || []).slice();
            this.polylineViagemLatLngs = JSON.parse(JSON.stringify(snap.polylineViagemLatLngs || []));
            this.trajetoDirecaoMarkers = JSON.parse(JSON.stringify(snap.trajetoDirecaoMarkers || []));
            this.inicioTrajetoLatLng = snap.inicioTrajetoLatLng ? snap.inicioTrajetoLatLng.slice() : null;
            this.inicioTrajetoTooltip = snap.inicioTrajetoTooltip;
            this.mapCercasCircularesViagem = JSON.parse(JSON.stringify(snap.mapCercasCircularesViagem || []));
            this.mapEmbarqueMarkersViagem = JSON.parse(JSON.stringify(snap.mapEmbarqueMarkersViagem || []));
            this.mapShowGpsTrack = snap.mapShowGpsTrack;
            this.mapShowPlannedRoute = snap.mapShowPlannedRoute;
            this.mapShowCercas = snap.mapShowCercas;
            this.mapShowEmbarques = snap.mapShowEmbarques;
            this.mapShowPassagemCercas = snap.mapShowPassagemCercas;
            this.mapShowDirecaoTrajeto = snap.mapShowDirecaoTrajeto;
        },
        stripGeoJsonPassagensParaReplay() {
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (!mo) return;
            const visit = (ly) => {
                if (!ly) return;
                if (ly._dvPassagemTextoCompacto != null) {
                    ly._dvPassagemTexto = "";
                    if (ly.getTooltip && ly.getTooltip()) {
                        ly.unbindTooltip();
                    }
                }
                if (ly.eachLayer) ly.eachLayer(visit);
            };
            mo.eachLayer(visit);
        },
        restaurarGeoJsonPassagensAposReplay() {
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (!mo) return;
            const show = this.mapShowPassagemCercas;
            const visit = (ly) => {
                if (!ly) return;
                if (ly._dvPassagemTextoCompacto != null) {
                    const texto = ly._dvPassagemTextoCompacto;
                    ly._dvPassagemTexto = texto;
                    if (texto && show) {
                        if (!ly.getTooltip || !ly.getTooltip()) {
                            ly.bindTooltip(texto, { ...(ly._dvPassagemOpts || this.tooltipPassagemCercaPermOptions) });
                        }
                    }
                }
                if (ly.eachLayer) ly.eachLayer(visit);
            };
            mo.eachLayer(visit);
        },
        passagemCercaDeveAparecerNoReplay(passageMs, currentMs, tripStartMs, temTexto) {
            if (!temTexto) return false;
            if (passageMs != null && tripStartMs != null && passageMs < tripStartMs) {
                return true;
            }
            if (passageMs != null && currentMs != null) {
                return currentMs >= passageMs;
            }
            return false;
        },
        atualizarCercasReplay(currentMs, tripStartMs) {
            (this.mapCercasCircularesViagem || []).forEach((c) => {
                const full = c._passagemTooltipCompleto != null ? c._passagemTooltipCompleto : c._passagemTooltipPermanente;
                const pm = c._passagemMs;
                const show = this.passagemCercaDeveAparecerNoReplay(pm, currentMs, tripStartMs, !!full);
                c._passagemTooltipPermanente = show ? full : "";
            });
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (!mo) return;
            const showPass = this.mapShowPassagemCercas;
            const visit = (ly) => {
                if (!ly) return;
                if (ly._dvPassagemTextoCompacto != null) {
                    const texto = ly._dvPassagemTextoCompacto;
                    const pm = ly._dvPassagemMs;
                    const show = this.passagemCercaDeveAparecerNoReplay(pm, currentMs, tripStartMs, !!texto);
                    ly._dvPassagemTexto = show ? texto : "";
                    if (show && showPass && texto) {
                        if (!ly.getTooltip || !ly.getTooltip()) {
                            ly.bindTooltip(texto, { ...(ly._dvPassagemOpts || this.tooltipPassagemCercaPermOptions) });
                        }
                    } else if (ly.getTooltip && ly.getTooltip()) {
                        ly.unbindTooltip();
                    }
                }
                if (ly.eachLayer) ly.eachLayer(visit);
            };
            mo.eachLayer(visit);
        },
        atualizarEmbarquesReplay(currentMs, tripStartMs) {
            const coords = this.embarquesComCoordenadas || [];
            const out = [];
            coords.forEach((item) => {
                if (!this.embarqueTemCoordenada(item)) return;
                const embMs = this.parseTimestampMs(item.dt_embarque);
                let vis = false;
                if (tripStartMs != null && embMs != null && embMs < tripStartMs) {
                    vis = true;
                } else if (embMs != null && currentMs != null) {
                    vis = embMs <= currentMs;
                }
                if (!vis) return;
                out.push({
                    id_embarque: item.id_embarque,
                    lat: item.lat,
                    lng: item.lng,
                    nome_completo: item.nome_completo,
                    dt_embarque_extenso: item.dt_embarque_extenso,
                    autorizado_extenso: item.autorizado_extenso,
                    autorizado: item.autorizado,
                    nome_cerca: item.nome_cerca,
                    cod_cerca: item.cod_cerca,
                });
            });
            this.mapEmbarqueMarkersViagem = out;
        },
        aplicarFrameReplayViagem(i) {
            const pairs = this._viagemReplayParesGps;
            if (!pairs || !pairs.length) return;
            const bounded = Math.min(Math.max(0, i), pairs.length - 1);
            const slice = pairs.slice(0, bounded + 1);
            this.polylineViagemLatLngs = slice.map((p) => [p.lat, p.lng]);
            const head = slice[slice.length - 1];
            this.replayVeiculoLatLng = [head.lat, head.lng];
            let currentMs = head.ms;
            if (currentMs == null) {
                const { tripStartMs, tripEndMs } = this.tripWindowMsMs();
                if (
                    tripStartMs != null &&
                    tripEndMs != null &&
                    !Number.isNaN(tripStartMs) &&
                    !Number.isNaN(tripEndMs) &&
                    tripEndMs >= tripStartMs &&
                    pairs.length > 1
                ) {
                    const r = bounded / (pairs.length - 1);
                    currentMs = Math.round(tripStartMs + r * (tripEndMs - tripStartMs));
                }
            }
            const { tripStartMs } = this.tripWindowMsMs();
            this.atualizarEmbarquesReplay(currentMs, tripStartMs);
            this.atualizarCercasReplay(currentMs, tripStartMs);
        },
        iniciarReproducaoTrajetoMapa() {
            const pairs = this.buildViagemReplayParesGps();
            if (pairs.length < 2) {
                EventBus.$emit("show-alert", {
                    mensagem: this.$t("detalhesViagem.map.replayNeedTrack"),
                    tipo: "warning",
                });
                return;
            }
            if (this.viagemReplayTimerId) {
                clearInterval(this.viagemReplayTimerId);
                this.viagemReplayTimerId = null;
            }
            if (this.viagemReplayEndTimerId) {
                clearTimeout(this.viagemReplayEndTimerId);
                this.viagemReplayEndTimerId = null;
            }
            this.viagemMapSnapshotReplay = this.capturarSnapshotMapaParaReplay();
            this._viagemReplayParesGps = pairs;
            this.viagemReplayAtivo = true;
            this.mapShowGpsTrack = true;
            this.mapShowEmbarques = true;
            this.mapShowPassagemCercas = true;
            this.trajetoDirecaoMarkers = [];
            this.$nextTick(() => {
                this.stripGeoJsonPassagensParaReplay();
                const n = pairs.length;
                const delayMs = n > 1500 ? 32 : n > 700 ? 48 : 62;
                let idx = 0;
                const tick = () => {
                    this.aplicarFrameReplayViagem(idx);
                    if (idx >= n - 1) {
                        if (this.viagemReplayTimerId) {
                            clearInterval(this.viagemReplayTimerId);
                            this.viagemReplayTimerId = null;
                        }
                        this.viagemReplayEndTimerId = setTimeout(() => {
                            this.viagemReplayEndTimerId = null;
                            this.pararReproducaoTrajetoMapa();
                        }, 420);
                        return;
                    }
                    idx += 1;
                };
                tick();
                this.viagemReplayTimerId = setInterval(tick, delayMs);
            });
        },
        pararReproducaoTrajetoMapa() {
            if (this.viagemReplayEndTimerId) {
                clearTimeout(this.viagemReplayEndTimerId);
                this.viagemReplayEndTimerId = null;
            }
            if (this.viagemReplayTimerId) {
                clearInterval(this.viagemReplayTimerId);
                this.viagemReplayTimerId = null;
            }
            const snap = this.viagemMapSnapshotReplay;
            this.viagemReplayAtivo = false;
            this.replayVeiculoLatLng = null;
            this._viagemReplayParesGps = null;
            if (snap) {
                this.restaurarSnapshotMapaReplay(snap);
                this.viagemMapSnapshotReplay = null;
                this.$nextTick(() => {
                    this.restaurarGeoJsonPassagensAposReplay();
                    this.syncPassagemCercasTooltips();
                    this.invalidateViagemMap();
                });
            }
        },
        toggleReproducaoTrajetoMapa() {
            if (this.viagemReplayAtivo) {
                this.pararReproducaoTrajetoMapa();
                return;
            }
            this.iniciarReproducaoTrajetoMapa();
        },
        resetCamadasMapaViagem() {
            this.posicoesViagem = [];
            this.polylineViagemLatLngs = [];
            this.trajetoDirecaoMarkers = [];
            this.inicioTrajetoLatLng = null;
            this.inicioTrajetoTooltip = "";
            this.mapRotasViagem = [];
            this.mapCercasGeojsonViagem = [];
            this.mapCercasCircularesViagem = [];
            this.mapEmbarqueMarkersViagem = [];
            this.mapaViagemMensagem = "";
        },
        async carregarMapaViagem() {
            this.pararReproducaoTrajetoMapa();
            const tk = this.tripKeyMapa();
            if (this.mapaTripKeyCarregado === tk && this.mapaTripKeyCarregado != null) {
                if (!this.viagemReplayAtivo) {
                    this.mapEmbarqueMarkersViagem = this.embarquesMarkersFromList();
                }
                return;
            }
            this.loadingMapaViagem = true;
            this.mapaViagemMensagem = "";
            this.resetCamadasMapaViagem();
            try {
                const idLinha = this.idLinhaParaMapa();
                const idVeiculo = this.idVeiculoParaMapa();
                const { dti, dtf } = this.janelaSqlViagem();
                if (!idLinha) {
                    this.mapaViagemMensagem = this.$t("detalhesViagem.map.missingData");
                    return;
                }
                const passMap = this.passagemPorIdCerca();
                const sentido = this.viagem.id_sentido;
                const temJanelaGps = idVeiculo && dti && dtf;

                const reqPosicoes = temJanelaGps
                    ? apiController.request(apiController.endpoints.getPosicoesporcarrodata, { data: { id: idVeiculo, dti, dtf }, silent: true })
                    : Promise.resolve({ data: [] });

                const [resPos, resRotas, resCercas] = await Promise.all([
                    reqPosicoes,
                    apiController.request(apiController.endpoints.getRotasporlinha, { data: [idLinha], silent: true }),
                    apiController.request(apiController.endpoints.getCercasporlinha, { data: [idLinha], silent: true })]);

                const posicoes = Array.isArray(resPos.data) ? resPos.data : [];
                this.posicoesViagem = posicoes;
                if (temJanelaGps && posicoes.length === 0) {
                    this.mapaViagemMensagem = this.$t("detalhesViagem.map.noPositions");
                }

                const latlngs = [];
                let primeiroHorarioPosicao = null;
                posicoes.forEach((p) => {
                    const la = parseFloat(p.lat);
                    const ln = parseFloat(p.lng);
                    if (!Number.isNaN(la) && !Number.isNaN(ln) && !(la === 0 && ln === 0)) {
                        if (latlngs.length === 0) {
                            primeiroHorarioPosicao = p.dt_posicao_extenso || p.dt_posicao || null;
                        }
                        latlngs.push([la, ln]);
                    }
                });
                this.polylineViagemLatLngs = latlngs;
                this.inicioTrajetoLatLng = latlngs.length ? [latlngs[0][0], latlngs[0][1]] : null;
                this.inicioTrajetoTooltip = primeiroHorarioPosicao
                    ? this.textoTooltipSomenteHorarioPassagem(primeiroHorarioPosicao)
                    : "";
                this.trajetoDirecaoMarkers = this.buildMarcadoresDirecaoTrajetoDesdePosicoes(posicoes, latlngs);

                const routeColors = ["#1565C0", "#2E7D32", "#6A1B9A"];
                const rotas = Array.isArray(resRotas.data) ? resRotas.data : [];
                this.mapRotasViagem = [];
                rotas.forEach((rota, idx) => {
                    if (sentido != null && sentido !== "" && Number(rota.id_sentido) !== Number(sentido)) {
                        return;
                    }
                    if (!rota.geojson) return;
                    let gj = rota.geojson;
                    if (typeof gj === "string") {
                        try {
                            gj = JSON.parse(gj);
                        } catch (e) {
                            return;
                        }
                    }
                    const color = routeColors[idx % routeColors.length];
                    this.mapRotasViagem.push({
                        ...rota,
                        geojson: gj,
                        style: { color, weight: 4, opacity: 0.82 },
                        options: {
                            onEachFeature: (feat, layer) => {
                                const name =
                                    (feat.properties && feat.properties.name) ||
                                    rota.nome_rota ||
                                    rota.cod_rota;
                                if (name) layer.bindPopup(String(name));
                            },
                        },
                    });
                });

                const cercaColors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#C62828"];
                let cercaColorIdx = 0;
                this.mapCercasGeojsonViagem = [];
                this.mapCercasCircularesViagem = [];
                const cercasLinha = Array.isArray(resCercas.data) ? resCercas.data : [];
                cercasLinha.forEach((cerca) => {
                    if (cerca.cod_tipo_cerca === "POI") return;
                    if (sentido != null && sentido !== "" && Number(cerca.id_sentido) !== Number(sentido) && Number(cerca.id_sentido) !== -1) {
                        return;
                    }
                    const color = cercaColors[cercaColorIdx % cercaColors.length];
                    cercaColorIdx += 1;
                    const horaPassagem = (passMap.get(String(cerca.id_cerca)) || "").trim();
                    const nome = cerca.nome_cerca || cerca.cod_cerca || "";
                    const textoHorarioPassagem = horaPassagem
                        ? this.textoTooltipSomenteHorarioPassagem(horaPassagem)
                        : "";

                    if (Number(cerca.is_circular) === 1) {
                        const r = Number(cerca.raio_mts);
                        if (
                            cerca.lat_centro == null ||
                            cerca.lng_centro == null ||
                            Number.isNaN(r) ||
                            r <= 0
                        ) {
                            return;
                        }
                        const rowCercaCirc = (this.cercas || []).find(
                            (r) => r && String(r.id_cerca) === String(cerca.id_cerca)
                        );
                        const passageMsCircular = this.parseTimestampMs(
                            rowCercaCirc &&
                                (rowCercaCirc.dt_passou_na_cerca || rowCercaCirc.dt_passou_na_cerca_extenso)
                        );
                        this.mapCercasCircularesViagem.push({
                            ...cerca,
                            _strokeColor: color,
                            _fillColor: color,
                            _passagemTooltipPermanente: textoHorarioPassagem,
                            _passagemTooltipCompleto: textoHorarioPassagem,
                            _passagemMs: passageMsCircular,
                        });
                        return;
                    }
                    if (!cerca.geojson) return;
                    let gj = cerca.geojson;
                    if (typeof gj === "string") {
                        try {
                            gj = JSON.parse(gj);
                        } catch (e) {
                            return;
                        }
                    }
                    this.mapCercasGeojsonViagem.push({
                        ...cerca,
                        geojson: gj,
                        style: {
                            color,
                            fillColor: color,
                            fillOpacity: 0.22,
                            weight: 2,
                        },
                        options: {
                            onEachFeature: (feat, layer) => {
                                const label = nome || (feat.properties && feat.properties.name) || "";
                                if (label) {
                                    layer.bindPopup(`<strong>${String(label)}</strong>`);
                                }
                                if (horaPassagem && textoHorarioPassagem) {
                                    const rowCercaGj = (this.cercas || []).find(
                                        (r) => r && String(r.id_cerca) === String(cerca.id_cerca)
                                    );
                                    const passageMsGeo = this.parseTimestampMs(
                                        rowCercaGj &&
                                            (rowCercaGj.dt_passou_na_cerca || rowCercaGj.dt_passou_na_cerca_extenso)
                                    );
                                    layer._dvPassagemTexto = textoHorarioPassagem;
                                    layer._dvPassagemTextoCompacto = textoHorarioPassagem;
                                    layer._dvPassagemMs = passageMsGeo;
                                    layer._dvPassagemOpts = { ...this.tooltipPassagemCercaPermOptions };
                                    if (this.mapShowPassagemCercas) {
                                        layer.bindTooltip(textoHorarioPassagem, layer._dvPassagemOpts);
                                    }
                                }
                            },
                        },
                    });
                });

                this.mapEmbarqueMarkersViagem = this.embarquesMarkersFromList();
                this.mapaTripKeyCarregado = tk;

                if (latlngs.length) {
                    const mid = Math.floor(latlngs.length / 2);
                    this.mapCenter = latlngs[mid].slice();
                } else if (this.mapEmbarqueMarkersViagem.length) {
                    const m0 = this.mapEmbarqueMarkersViagem[0];
                    this.mapCenter = [parseFloat(m0.lat), parseFloat(m0.lng)];
                } else {
                    this.mapCenter = MAP_DEFAULT_CENTER.slice();
                }
            } catch (error) {
                this.resetCamadasMapaViagem();
                EventBus.$emit("show-error", { error });
            } finally {
                this.loadingMapaViagem = false;
                this.$nextTick(() => this.syncPassagemCercasTooltips());
            }
        },
        embarquesMarkersFromList() {
            return (this.embarquesComCoordenadas || [])
                .filter((e) => this.embarqueTemCoordenada(e))
                .map((item) => ({
                    id_embarque: item.id_embarque,
                    lat: item.lat,
                    lng: item.lng,
                    nome_completo: item.nome_completo,
                    dt_embarque_extenso: item.dt_embarque_extenso,
                    autorizado_extenso: item.autorizado_extenso,
                    autorizado: item.autorizado,
                    nome_cerca: item.nome_cerca,
                    cod_cerca: item.cod_cerca,
                }));
        },
        embarqueTemCoordenada(item) {
            if (!item || item.lat == null || item.lng == null) return false;
            const lat = parseFloat(item.lat);
            const lng = parseFloat(item.lng);
            return !Number.isNaN(lat) && !Number.isNaN(lng) && !(lat === 0 && lng === 0);
        },
        corMarcadorAutorizado(autorizado) {
            const nome = autorizado == 1 ? "green" : autorizado == 2 ? "orange" : "red";
            const theme = this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.currentTheme;
            if (theme && theme[nome]) {
                return theme[nome];
            }
            const fallback = { green: "#4CAF50", orange: "#FB8C00", red: "#F44336" };
            return fallback[nome];
        },
        iconEmbarqueViagem(reg) {
            const fill = this.corMarcadorAutorizado(reg && reg.autorizado);
            const w = 28;
            const h = 36;
            const html =
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 46" width="${w}" height="${h}" aria-hidden="true">` +
                `<path d="M18 1 C8.6 1 1 8.6 1 18 C1 28 18 45 18 45 C18 45 35 28 35 18 C35 8.6 27.4 1 18 1 Z" ` +
                `fill="${fill}" stroke="#ffffff" stroke-width="2" stroke-linejoin="round"/>` +
                `<circle cx="18" cy="17" r="8.5" fill="#ffffff"/>` +
                `<g transform="translate(10 9) scale(0.667)">` +
                `<path d="${mdiAccount}" fill="${fill}"/>` +
                `</g>` +
                `</svg>`;
            return L.divIcon({
                className: "detalhesviagem-mdi-marker",
                html,
                iconSize: [w, h],
                iconAnchor: [w / 2, h - 2],
                popupAnchor: [0, -(h - 2)],
            });
        },
        latLngPair(lat, lng) {
            const fallback = L.latLng(MAP_DEFAULT_CENTER[0], MAP_DEFAULT_CENTER[1]);
            if (lat == null || lng == null) return fallback;
            const la = typeof lat === "number" ? lat : parseFloat(String(lat).trim().replace(",", "."));
            const ln = typeof lng === "number" ? lng : parseFloat(String(lng).trim().replace(",", "."));
            if (Number.isNaN(la) || Number.isNaN(ln)) return fallback;
            if (la === 0 && ln === 0) return fallback;
            return L.latLng(la, ln);
        },
        invalidateViagemMap() {
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (mo) {
                mo.invalidateSize();
            }
        },
        onViagemMapReady() {
            this.invalidateViagemMap();
            setTimeout(() => {
                this.invalidateViagemMap();
                this.syncPassagemCercasTooltips();
                this.ajustarBoundsViagemMap();
            }, 120);
        },
        ajustarBoundsViagemMap() {
            const mo = this.$refs.viagemMap && this.$refs.viagemMap.mapObject;
            if (!mo) return;
            const pts = [];
            (this.polylineViagemLatLngs || []).forEach((ll) => {
                if (ll && ll.length === 2) {
                    const la = ll[0];
                    const ln = ll[1];
                    if (!Number.isNaN(la) && !Number.isNaN(ln)) pts.push(L.latLng(la, ln));
                }
            });
            (this.mapEmbarqueMarkersViagem || []).forEach((m) => {
                if (this.embarqueTemCoordenada(m)) pts.push(L.latLng(parseFloat(m.lat), parseFloat(m.lng)));
            });
            (this.mapCercasCircularesViagem || []).forEach((c) => {
                if (c.lat_centro != null && c.lng_centro != null) {
                    pts.push(L.latLng(parseFloat(c.lat_centro), parseFloat(c.lng_centro)));
                }
            });
            (this.trajetoDirecaoMarkers || []).forEach((d) => {
                if (d.lat != null && d.lng != null) {
                    const la = parseFloat(d.lat);
                    const ln = parseFloat(d.lng);
                    if (!Number.isNaN(la) && !Number.isNaN(ln)) pts.push(L.latLng(la, ln));
                }
            });
            if (pts.length === 1) {
                mo.setView(pts[0], 15, { animate: false });
                mo.invalidateSize();
                return;
            }
            const bounds = L.latLngBounds(pts);
            mo.fitBounds(bounds, { animate: false, maxZoom: 16, padding: [40, 40] });
            mo.invalidateSize();
        },
        async exportMapPdf() {
            const div = this.$refs.viagemMapPdfWrap;
            if (!div) {
                EventBus.$emit("show-alert", {
                    mensagem: this.$t("detalhesViagem.map.missingData"),
                    tipo: "warning",
                });
                return;
            }
            this.exportingMapPdf = true;
            this.invalidateViagemMap();
            await this.$nextTick();
            await new Promise((r) => setTimeout(r, 200));
            try {
                const dataUrl = await domtoimage.toPng(div);
                const img = new Image();
                img.src = dataUrl;
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = reject;
                });
                const doc = new jsPDF({
                    orientation: "l",
                    format: "a4",
                });
                doc.addImage(dataUrl, "PNG", 5, 5, 285, 195);
                const date = new Date();
                const base = this.$t("detalhesViagem.map.title").replace(/\s+/g, "_");
                const filename =
                    `${base}_` +
                    date.getFullYear() +
                    ("0" + (date.getMonth() + 1)).slice(-2) +
                    ("0" + date.getDate()).slice(-2) +
                    ("0" + date.getHours()).slice(-2) +
                    ("0" + date.getMinutes()).slice(-2) +
                    ("0" + date.getSeconds()).slice(-2) +
                    ".pdf";
                doc.save(filename);
            } catch (error) {
                console.error(error);
                EventBus.$emit("show-alert", {
                    mensagem: String((error && error.message) || error || "PDF"),
                    tipo: "error",
                });
            } finally {
                this.exportingMapPdf = false;
            }
        },
        initialize() {
            this.pararReproducaoTrajetoMapa();
            this.mapaTripKeyCarregado = null;
            this.viagemMapPanel = null;
            this.resetCamadasMapaViagem();
            this.populaCercas();
            this.populaEventos();
        },
        async populaCercas() {
            const idViagemGrid = this.viagem.id_viagem_grid;
            const idViagemRealizada = this.viagem.id_viagem_realizada;

            if (this.tempoReal) {
                if (!idViagemRealizada) {
                    return;
                }
            } else if (!idViagemGrid) {
                return;
            }

            this.loadingCercas = true;
            try {
                const endpoint = this.tempoReal
                    ? apiController.endpoints.getEtaviagem
                    : apiController.endpoints.getViagemgridcercas;
                const params = this.tempoReal
                    ? { idviagem: idViagemRealizada }
                    : { idviagemgrid: idViagemGrid };

                const response = await apiController.request(endpoint, { params, silent: true });

                if (response.data?.erro) {
                    this.cercas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem || this.$t('detalhesViagem.errors.loadFences'),
                        tipo: 'error'
                    });
                    return;
                }

                if (!Array.isArray(response.data)) {
                    this.cercas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('detalhesViagem.errors.invalidResponse'),
                        tipo: 'warning'
                    });
                    return;
                }

                this.cercas = response.data.map((row) => {
                    if (!row) return row;
                    const passou = row.dt_passou_na_cerca != null && row.dt_passou_na_cerca !== "";
                    if (passou) return row;
                    return {
                        ...row,
                        dt_passou_na_cerca: null,
                        dt_passou_na_cerca_extenso: this.$t('detalhesViagem.fences.timelineLegendMissed'),
                    };
                });
            } catch (error) {
                this.cercas = [];
                EventBus.$emit('show-error', { error });
            } finally {
                this.loadingCercas = false;
            }
        },

        async populaEventos() {
            const idViagemGrid = this.viagem.id_viagem_grid;
            const idViagemRealizada = this.viagem.id_viagem_realizada;

            if (!idViagemGrid && !idViagemRealizada) {
                this.eventos = [];
                this.embarquesComCoordenadas = [];
                this.taxaOcupacao = 0;
                EventBus.$emit('show-alert', {
                    mensagem: this.$t('detalhesViagem.errors.noTripIdentifier'),
                    tipo: 'warning'
                });
                return;
            }

            this.loadingEventos = true;
            try {
                const response = await apiController.request(apiController.endpoints.getEmbarquesporviagem, {
                    data: {
                        ...(idViagemGrid ? { id_viagem_grid: idViagemGrid } : {}),
                        ...(!idViagemGrid && idViagemRealizada ? { id_viagem_realizada: idViagemRealizada } : {}),
                    },
                    silent: true,
                });

                console.log(idViagemGrid);
                console.log(idViagemRealizada);

                if (response.data?.erro) {
                    this.eventos = [];
                    this.embarquesComCoordenadas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem || this.$t('detalhesViagem.errors.errorLoadingEvents'),
                        tipo: 'error'
                    });
                    return;
                }

                const dadosEmbarques = response.data?.dados || [];
                this.embarquesComCoordenadas = dadosEmbarques.filter((e) => this.embarqueTemCoordenada(e));
                const pessoasDistintas = new Map();
                dadosEmbarques.forEach((embarque) => {
                    const chave = embarque.id_pessoa != null && embarque.id_pessoa !== ''
                        ? embarque.id_pessoa
                        : embarque.nome_completo;
                    if (chave == null || chave === '') {
                        return;
                    }
                    if (!pessoasDistintas.has(chave)) {
                        pessoasDistintas.set(chave, embarque);
                    }
                });
                this.eventos = Array.from(pessoasDistintas.values());
                this.calcularTaxaOcupacao();
                if (this.mapaTripKeyCarregado === this.tripKeyMapa() && !this.viagemReplayAtivo) {
                    this.mapEmbarqueMarkersViagem = this.embarquesMarkersFromList();
                }
            } catch (error) {
                this.eventos = [];
                this.embarquesComCoordenadas = [];
                this.taxaOcupacao = 0;
                this.veiculo = null;
                EventBus.$emit('show-error', { error });
            } finally {
                this.loadingEventos = false;
            }
        },
        calcularTaxaOcupacao() {
            if (!this.eventos || this.eventos.length === 0) {
                this.taxaOcupacao = 0;
                return;
            }

            const capacidadeMaxima = this.viagem?.lotacao || 0;

            if (capacidadeMaxima === 0) {
                this.taxaOcupacao = 0;
                return;
            }

            const totalPessoas = this.eventos.filter(evento => evento.autorizado === 1 || evento.autorizado === 2).length;

            this.taxaOcupacao = ((totalPessoas / capacidadeMaxima) * 100).toFixed(2);

            if (this.taxaOcupacao > 100) {
                this.taxaOcupacao = 100;
            }
        },
        close() {
            this.pararReproducaoTrajetoMapa();
            this.cercas = [];
            this.mapaTripKeyCarregado = null;
            this.viagemMapPanel = null;
            this.resetCamadasMapaViagem();
            this.$emit('close');
        },
        embarqueRowClass(item) {
            const a = item && item.autorizado;
            const n = a === null || a === undefined || a === '' ? NaN : Number(a);
            if (n === 0) {
                return 'embarque-row--denied';
            }
            if (n === 1) {
                return '';
            }
            return 'embarque-row--wrong-route';
        },
    }
}
</script>
<style scoped>
.emb-stat-block {
    min-height: 48px;
    padding: 4px 0;
}

.detalhes-viagem-map-wrap {
    width: 100%;
    height: 62vh;
    min-height: 360px;
    position: relative;
}

.detalhes-viagem-map-fab {
    position: absolute;
    right: 14px;
    bottom: 22px;
    z-index: 1100;
    pointer-events: auto;
}

.detalhes-viagem-map-pdf-inner {
    width: 100%;
    height: 100%;
    position: relative;
}

.detalhes-viagem-lmap {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    z-index: 1;
}

::v-deep tr.embarque-row--denied {
    color: red !important;
    font-weight: bold !important;
}

::v-deep tr.embarque-row--wrong-route {
    color: rgb(255, 123, 0) !important;
    font-weight: bold !important;
}
</style>
<style>
.detalhesviagem-mdi-marker {
    background: transparent !important;
    border: none !important;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.45));
}

.detalhes-viagem-dir-marker {
    background: transparent !important;
    border: none !important;
    pointer-events: none !important;
}

.detalhes-viagem-dir-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: 50% 50%;
}

.detalhes-viagem-inicio-trajeto-marker {
    background: transparent !important;
    border: none !important;
    pointer-events: none !important;
}

.detalhes-viagem-inicio-trajeto-dot {
    border-radius: 50%;
    background: rgba(229, 81, 0, 0.9);
    border: 1px solid #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
}

.leaflet-tooltip.detalhes-viagem-cerca-passagem-tt {
    background: rgba(255, 255, 255, 0.72);
    color: #212121;
    border: 1px solid rgba(0, 0, 0, 0.12);
    font-weight: 500;
    font-size: 10px;
    line-height: 1.15;
    padding: 1px 5px;
    margin: -4px 0 0 0;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    pointer-events: none;
    white-space: nowrap;
}

.leaflet-tooltip.detalhes-viagem-cerca-passagem-tt::before {
    border-top-color: rgba(255, 255, 255, 0.72);
}

.detalhes-viagem-replay-veiculo-marker {
    background: transparent !important;
    border: none !important;
    pointer-events: none !important;
}

.detalhes-viagem-replay-veiculo-dot {
    border-radius: 50%;
    background: #e65100;
    border: 2px solid #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.35);
}
</style>
